__webpack_require__.p = "http://global.xuniuwang.com/index/king/";